import log from 'loglevel';
import DocModuleDB from './db/DB';
import DBDataParser from './db/DBDataParser';

/**
 *
 * Created Date: 2019-04-19, 15:57:21 (zhenliang.sun)
 * Last Modified: 2019-07-29, 16:58:59 (zhenliang.sun)
 * Email: zhenliang.sun@gmail.com
 *
 * Distributed under the MIT license. See LICENSE file for details.
 * Copyright (c) 2019 vhall
 */

/**
 * 数据库操作相关包装
 *
 * @export
 * @class DBController
 * @author zhenliang.sun
 */
export default class DBController {
  constructor() {
    this.CLASS_NAME = this.constructor.name;
    this._db = null;
    this._dbStore = null;
    window.dataInstallComplete = false;
  }

  /**
   * 数据库控制器初始化
   *
   * @param {*} option 初始化配置信息
   * @memberof DBController
   */
  init(option) {
    if (this.db) {
      log.info('warn', 'DB had already initialized');
      return;
    }

    log.info('DB init.');
    this._db = new DocModuleDB(option);
    this.db.connect();
    this._dbStore = this.db.use(option['use']);

    const beforeClear = Date.now();
    this.dbStore.clear();
    log.info(`clear old data. cost: ${Date.now() - beforeClear}ms.`);

    log.info('DB init complete.');
  }

  /**
   * 数据安装
   *
   * @param {*} data
   * @memberof DBController
   */
  async install(data) {
    if (!this.db) {
      log.error('DB have not been initialized.');
      return;
    }

    if (!this.dbStore) {
      log.error('DB Store have not been selected.');
      return;
    }

    if (!data) {
      log.error('DB data is empty.');
      return;
    }

    const beforeParse = Date.now();
    let dbData = DBDataParser.parse(data);
    log.info(`DB data parse. cost: ${Date.now() - beforeParse}ms.`);

    const beforeInsert = Date.now();
    for (const item of dbData) {
      await this.dbStore.put(item);
    }
    log.info(`DB data insert. cost: ${Date.now() - beforeInsert}ms.`);

    const count = await this.dbStore.count();
    log.info(`There are ${count} pieces data in DB.`);
    log.info('Data install complete.');
    window.dataInstallComplete = true;
  }

  /**
   * 销毁数据库控制器、清空当前数据
   *
   * @memberof DBController
   */
  destroy() {
    if (this.dbStore) {
      this.dbStore.clear();
      this._dbStore = null;
    }

    if (this.db) {
      this.db.close();
      this._db = null;
    }

    window.dataInstallComplete = false;
  }

  // =================== DB operate ====================================

  async getData(key) {
    return this.dbStore.get(key);
  }

  async first() {
    return this.dbStore.first();
  }

  async last() {
    return this.dbStore.last();
  }

  async all() {
    return this.dbStore.all();
  }

  async count() {
    return this.dbStore.count();
  }

  async query(key, value, compare) {
    return this.dbStore.query(key, value, compare);
  }

  async select(condition = []) {
    if (condition.length === 0) {
      return [];
    }

    return this.dbStore.select(condition);
  }

  // =================== DB operate end ================================

  /**
   * 获取数据库实例
   *
   * @readonly
   * @memberof DBController
   */
  get db() {
    return this._db;
  }

  /**
   * 获取当前操作的表
   *
   * @readonly
   * @memberof DBController
   */
  get dbStore() {
    return this._dbStore;
  }
}
